import { Typography } from '@material-ui/core'
import { useStyles } from './styles'
const BigText = (props) => {
  const { text } = props
  const classes = useStyles()
  return (
    <Typography variant="h2" classes={{ root: classes.root }}>
      {text}
    </Typography>
  )
}
export default BigText
